import { render, staticRenderFns } from "./ratetab.vue?vue&type=template&id=690717b9"
import script from "./ratetab.vue?vue&type=script&lang=js"
export * from "./ratetab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports